import { render, staticRenderFns } from "./PenilaianClassEvent.vue?vue&type=template&id=4ef377ca&scoped=true&"
import script from "./PenilaianClassEvent.vue?vue&type=script&lang=js&"
export * from "./PenilaianClassEvent.vue?vue&type=script&lang=js&"
import style0 from "./PenilaianClassEvent.vue?vue&type=style&index=0&id=4ef377ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef377ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
